import { Icon } from '@chakra-ui/icons'
import { IconProps } from '@chakra-ui/react'
import { FC, SVGProps } from 'react'

const Phyto: FC<IconProps> = (props) => (
  <Icon
    fill="#fff"
    viewBox="0 0 978.673 978.673"
    style={{
      // @ts-ignore
      enableBackground: 'new 0 0 978.673 978.673'
    }}
    {...props}
  >
    <path d="M64.126 214.123c35.6 82.801 95.7 164.7 179.8 200.001 9.6 4 20.5 7 31.7 9.5 22.4-33.4 48.1-60.501 78.2-82.7 25.899-19 53-33.9 80.899-45.601-8-5.6-16.399-10.7-25.2-15.3-35-18.3-72.899-34.4-109.8-51.7 34.7 9.4 74.5 12.9 107.7 25 20.7 7.601 39.8 18.101 57.6 30.601 53.101-18.101 108.601-26.801 164-33.4-44.899-74.6-140.7-134.5-212.9-161.6-75.4-28.301-160.8-31.801-244.7-40.5-51.4-5.301-107.3-24.5-148.2-46.9-9.3-5.1-19.2 3.4-16 13.7 20.101 64.299 30.301 137.099 56.901 198.899z" />
    <path d="M950.627 204.323c-94.601 51.4-203.101 57.7-309.4 69.9-51.899 6-103.3 13.399-152.201 28.2-10.6 3.199-21.199 6.8-31.6 10.8-30.9 11.8-60.7 27.3-88.8 48-26.4 19.399-48 42.4-66.2 67.7-29 40.399-49.2 86.899-65.8 135.2-30.3 87.699-44.2 180.899-41.5 273.6 1.1 37.6 1.7 76.7 11 113.4 2.1 8.1 4.1 18.399 10.4 24.399 8.2 7.9 22.9-.2 19.6-11.7-23.8-81.1-9-175.899 23.9-253.399 37.8-89.101 110.8-142.101 200-174.4 23.7-8.6 47.901-16.1 72.5-23.2.5-.199 1-.199 1.5-.199 4.9 0 7 7.199 1.9 9.5-29 13.1-57.8 26.3-85.201 40.6-134.2 70-192.8 233-142.5 233 4.101 0 8.9-1.1 14.4-3.4 77.6-32.1 169.8-32.399 255.1-48.199 30-5.5 59.2-13 86.601-24.4 108.8-45.4 186.6-134.2 232.899-241 34.5-79.7 47.9-173.8 74-256.601 3.4-10.6-4.1-19.699-13.3-19.699-2.298-.102-4.798.499-7.298 1.898z" />
  </Icon>
)

export default Phyto
